import { useLocation, useRoutes } from 'react-router-dom';
import routes from './routes';
import StagingGate from './app/components/StagingGate';
import ErrorBoundary from './app/components/ErrorBoundary';

const App = (props: any) => {
  const element = useRoutes(routes)
  const location = useLocation();
  return (
    <StagingGate>
      <ErrorBoundary resetKey={location.pathname}>{element}</ErrorBoundary>
    </StagingGate>
  )
}

export default App;
